import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ScrollToTopButton from "./components/feature/ScrollToTopButton";
import { useLanguageSync } from "./components/feature/LanguageSync";

function AppInner() {
  useLanguageSync();
  return (
    <>
      <AppRoutes />
      <ScrollToTopButton />
    </>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppInner />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;